export const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400&family=DM+Sans:wght@300;400;500;600&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  :root {
    --pink:      #F4A7C0;
    --rose:      #D4537E;
    --mauve:     #8B4F6B;
    --blush:     #FDF0F5;
    --text:      #1a1a1a;
    --muted:     #6b6b6b;
    --white:     #ffffff;
  }

  html { scroll-behavior: smooth; }

  body {
    font-family: 'DM Sans', sans-serif;
    background: var(--white);
    color: var(--text);
    overflow-x: hidden;
  }

  /* ── Nav ── */
  .s-nav {
    position: fixed; top: 0; left: 0; right: 0; z-index: 100;
    padding: 1.1rem 2rem;
    display: flex; justify-content: space-between; align-items: center;
    background: rgba(255,255,255,0.92);
    backdrop-filter: blur(14px);
    border-bottom: 1px solid rgba(244,167,192,0.25);
    transition: box-shadow 0.3s;
  }
  .s-nav.scrolled { box-shadow: 0 2px 20px rgba(212,83,126,0.08); }

  .s-logo {
    font-family: 'Playfair Display', serif;
    font-size: 1.5rem; color: var(--rose);
    letter-spacing: -0.02em; cursor: default;
    display: flex; align-items: center; gap: 4px;
  }
  .s-logo-dot {
    width: 8px; height: 8px;
    background: var(--pink); border-radius: 50%;
    display: inline-block; margin-bottom: 2px;
  }

  .s-nav-btn {
    background: var(--rose); color: white; border: none;
    padding: 0.55rem 1.3rem; border-radius: 100px;
    font-family: 'DM Sans', sans-serif; font-size: 0.85rem; font-weight: 500;
    cursor: pointer; transition: background 0.2s, transform 0.15s;
    text-decoration: none; display: inline-block;
  }
  .s-nav-btn:hover { background: var(--mauve); transform: scale(1.03); }

  /* ── Hero ── */
  .s-hero {
    min-height: 100vh;
    display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    text-align: center;
    padding: 9rem 1.5rem 5rem;
    background: linear-gradient(160deg, #fff 0%, #FDF0F5 55%, #fff 100%);
    position: relative; overflow: hidden;
  }
  .s-hero::before {
    content: ''; position: absolute;
    width: 650px; height: 650px; border-radius: 50%;
    background: radial-gradient(circle, rgba(244,167,192,0.18) 0%, transparent 70%);
    top: -120px; right: -220px; pointer-events: none;
  }
  .s-hero::after {
    content: ''; position: absolute;
    width: 420px; height: 420px; border-radius: 50%;
    background: radial-gradient(circle, rgba(212,83,126,0.07) 0%, transparent 70%);
    bottom: 0; left: -120px; pointer-events: none;
  }

  .s-badge {
    display: inline-flex; align-items: center; gap: 6px;
    background: rgba(244,167,192,0.2); color: var(--mauve);
    border: 1px solid rgba(244,167,192,0.45);
    padding: 0.38rem 1rem; border-radius: 100px;
    font-size: 0.78rem; font-weight: 500; letter-spacing: 0.03em;
    margin-bottom: 1.75rem;
    animation: fadeUp 0.6s ease both;
  }
  .s-badge::before {
    content: ''; width: 6px; height: 6px;
    background: var(--rose); border-radius: 50%;
  }

  .s-tagline {
    font-family: 'Playfair Display', serif;
    font-style: italic; font-size: 1rem;
    color: var(--mauve); margin-bottom: 0.6rem;
    animation: fadeUp 0.6s 0.05s ease both;
  }

  .s-h1 {
    font-family: 'Playfair Display', serif;
    font-size: clamp(3rem, 7.5vw, 5.8rem);
    line-height: 1.08; letter-spacing: -0.035em;
    max-width: 820px; margin-bottom: 1.5rem;
    animation: fadeUp 0.6s 0.1s ease both;
  }
  .s-h1 em { font-style: italic; color: var(--rose); }

  .s-hero-sub {
    font-size: clamp(0.95rem, 2vw, 1.15rem);
    color: var(--muted); max-width: 500px;
    line-height: 1.75; font-weight: 300;
    margin-bottom: 2.5rem;
    animation: fadeUp 0.6s 0.18s ease both;
  }

  .s-form {
    display: flex; gap: 0.7rem;
    max-width: 440px; width: 100%;
    flex-wrap: wrap; justify-content: center;
    animation: fadeUp 0.6s 0.26s ease both;
  }
  .s-form input {
    flex: 1; min-width: 200px;
    padding: 0.88rem 1.2rem;
    border: 1.5px solid rgba(244,167,192,0.55);
    border-radius: 100px;
    font-family: 'DM Sans', sans-serif; font-size: 0.95rem;
    outline: none; background: white; color: var(--text);
    transition: border-color 0.2s;
  }
  .s-form input:focus { border-color: var(--rose); }
  .s-form input::placeholder { color: #c0b0b8; }

  .s-btn {
    background: var(--rose); color: white; border: none;
    padding: 0.88rem 1.8rem; border-radius: 100px;
    font-family: 'DM Sans', sans-serif; font-size: 0.95rem; font-weight: 500;
    cursor: pointer; white-space: nowrap;
    box-shadow: 0 4px 22px rgba(212,83,126,0.32);
    transition: background 0.2s, transform 0.15s, box-shadow 0.15s;
  }
  .s-btn:hover { background: var(--mauve); transform: translateY(-2px); box-shadow: 0 8px 30px rgba(212,83,126,0.38); }

  .s-success {
    color: var(--mauve); font-weight: 500;
    font-size: 0.95rem; margin-top: 0.75rem;
    animation: fadeUp 0.4s ease both;
  }

  .s-social {
    display: flex; align-items: center; gap: 0.6rem;
    margin-top: 1.8rem; font-size: 0.82rem; color: var(--muted);
    animation: fadeUp 0.6s 0.34s ease both;
  }
  .s-avatars { display: flex; }
  .s-avatar {
    width: 28px; height: 28px; border-radius: 50%;
    border: 2px solid white; margin-left: -7px;
    font-size: 10px; display: flex; align-items: center;
    justify-content: center; font-weight: 600; color: white;
  }
  .s-avatar:first-child { margin-left: 0; }

  /* ── Section shared ── */
  .s-label {
    text-align: center; font-size: 0.74rem;
    letter-spacing: 0.13em; text-transform: uppercase;
    color: var(--rose); font-weight: 500; margin-bottom: 0.8rem;
  }
  .s-title {
    font-family: 'Playfair Display', serif;
    font-size: clamp(1.9rem, 4vw, 3rem);
    text-align: center; letter-spacing: -0.025em;
    margin-bottom: 3rem; color: var(--text);
  }

  /* ── Features ── */
  .s-features { padding: 6rem 1.5rem; max-width: 1100px; margin: 0 auto; }
  .s-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(230px, 1fr)); gap: 1.4rem; }

  .s-card {
    background: var(--blush); border-radius: 20px;
    padding: 2rem; opacity: 0;
    transition: transform 0.25s, box-shadow 0.25s;
  }
  .s-card.visible { opacity: 1; animation: fadeUp 0.55s ease both; }
  .s-card:hover { transform: translateY(-5px); box-shadow: 0 16px 40px rgba(212,83,126,0.12); }

  .s-card-icon {
    width: 48px; height: 48px;
    background: rgba(212,83,126,0.1); border-radius: 14px;
    display: flex; align-items: center; justify-content: center;
    font-size: 22px; margin-bottom: 1.2rem;
  }
  .s-card h3 { font-family: 'Playfair Display', serif; font-size: 1.15rem; margin-bottom: 0.5rem; }
  .s-card p { font-size: 0.88rem; color: var(--muted); line-height: 1.7; font-weight: 300; }

  /* ── Screenshots ── */
  .s-shots { padding: 6rem 1.5rem; background: white; text-align: center; overflow: hidden; }
  .s-shots-row {
    display: flex; gap: 1.4rem;
    overflow-x: auto; padding: 2rem 1rem;
    justify-content: center; flex-wrap: wrap;
    scrollbar-width: none;
  }
  .s-shots-row::-webkit-scrollbar { display: none; }
  .s-shot {
    flex: 0 0 auto; width: 260px;
    border-radius: 22px; overflow: hidden;
    box-shadow: 0 22px 60px rgba(212,83,126,0.14);
    transition: transform 0.3s;
  }
  .s-shot:hover { transform: translateY(-8px); }
  .s-shot img { width: 100%; display: block; }

  /* ── Chat ── */
  .s-chat {
    padding: 5.5rem 1.5rem;
    background: linear-gradient(155deg, #f9d0e0 0%, #e8cff0 55%, #f9d0e0 100%);
  }
  .s-chat-inner { max-width: 400px; margin: 0 auto; text-align: center; }
  .s-chat-window { margin-top: 2.5rem; text-align: left; }
  .s-chat-header {
    display: flex; flex-direction: column; align-items: center;
    padding-bottom: 1.4rem; gap: 2px;
  }
  .s-chat-name { font-weight: 700; font-size: 1rem; color: #1a1a1a; }

  .s-msg { margin-bottom: 0.7rem; display: flex; flex-direction: column; }
  .s-msg.user { align-items: flex-end; }
  .s-msg.bot  { align-items: flex-start; }

  .s-bubble {
    max-width: 84%; padding: 0.82rem 1rem;
    border-radius: 18px; font-size: 0.92rem; line-height: 1.58;
  }
  .s-msg.user .s-bubble { background: #F4A7C0; color: #1a1a1a; border-bottom-right-radius: 4px; }
  .s-msg.bot  .s-bubble { background: white; color: #1a1a1a; box-shadow: 0 2px 10px rgba(0,0,0,0.07); border-bottom-left-radius: 4px; }

  .s-ts { font-size: 0.68rem; color: #aaa; margin-top: 4px; padding: 0 3px; }

  @keyframes blink { 0%,60%,100% { opacity:.3; transform:translateY(0); } 30% { opacity:1; transform:translateY(-3px); } }
  .s-dot { display: inline-block; width: 5px; height: 5px; border-radius: 50%; background: var(--muted); margin: 0 2px; animation: blink 1.2s infinite; }
  .s-dot:nth-child(2) { animation-delay: 0.2s; }
  .s-dot:nth-child(3) { animation-delay: 0.4s; }

  /* ── Tracker ── */
  .s-tracker { padding: 6rem 1.5rem; max-width: 860px; margin: 0 auto; text-align: center; }
  .s-tracker-desc { color: var(--muted); font-weight: 300; max-width: 460px; margin: 0 auto; line-height: 1.75; font-size: 0.95rem; }
  .s-tracker-cards { display: grid; grid-template-columns: repeat(auto-fit, minmax(170px, 1fr)); gap: 1.4rem; margin-top: 3rem; }
  .s-tcard {
    background: var(--blush); border-radius: 20px;
    padding: 2rem 1.5rem; border: 1px solid rgba(244,167,192,0.3);
    opacity: 0;
  }
  .s-tcard.visible { opacity: 1; animation: fadeUp 0.55s ease both; }
  .s-tnum { font-family: 'Playfair Display', serif; font-size: 3.5rem; color: var(--rose); line-height: 1; margin-bottom: 0.5rem; }
  .s-tlabel { font-size: 0.84rem; color: var(--muted); }

  /* ── CTA ── */
  .s-cta {
    padding: 6rem 1.5rem; text-align: center;
    background: var(--rose); position: relative; overflow: hidden;
  }
  .s-cta::before {
    content: ''; position: absolute;
    width: 520px; height: 520px; border-radius: 50%;
    background: rgba(255,255,255,0.06);
    top: -210px; right: -110px;
  }
  .s-cta h2 {
    font-family: 'Playfair Display', serif;
    font-size: clamp(2rem, 5vw, 3.6rem);
    color: white; letter-spacing: -0.025em;
    margin-bottom: 0.9rem; position: relative;
  }
  .s-cta-sub {
    color: rgba(255,255,255,0.76); font-size: 1rem;
    margin-bottom: 2.5rem; font-weight: 300; position: relative;
  }
  .s-cta-form {
    display: flex; gap: 0.7rem; max-width: 430px;
    margin: 0 auto; flex-wrap: wrap; justify-content: center;
    position: relative;
  }
  .s-cta-form input {
    flex: 1; min-width: 200px;
    padding: 0.88rem 1.2rem;
    border: 1.5px solid rgba(255,255,255,0.32);
    border-radius: 100px;
    font-family: 'DM Sans', sans-serif; font-size: 0.95rem;
    background: rgba(255,255,255,0.13); color: white; outline: none;
    transition: border-color 0.2s;
  }
  .s-cta-form input::placeholder { color: rgba(255,255,255,0.52); }
  .s-cta-form input:focus { border-color: rgba(255,255,255,0.75); }
  .s-btn-white {
    background: white; color: var(--rose); border: none;
    padding: 0.88rem 1.8rem; border-radius: 100px;
    font-family: 'DM Sans', sans-serif; font-size: 0.95rem; font-weight: 500;
    cursor: pointer; white-space: nowrap;
    box-shadow: 0 4px 22px rgba(0,0,0,0.14);
    transition: transform 0.15s, box-shadow 0.15s;
  }
  .s-btn-white:hover { transform: translateY(-2px); box-shadow: 0 8px 30px rgba(0,0,0,0.2); }
  .s-cta-success { color: rgba(255,255,255,0.92); font-weight: 500; margin-top: 1rem; animation: fadeUp 0.4s ease both; }

  /* ── Footer ── */
  .s-footer {
    padding: 2rem 1.5rem; text-align: center;
    font-size: 0.8rem; color: var(--muted);
    border-top: 1px solid rgba(244,167,192,0.22);
  }
  .s-footer a { color: var(--muted); text-decoration: underline; transition: color 0.15s; }
  .s-footer a:hover { color: var(--rose); }
  .s-footer-links { margin-top: 0.6rem; display: flex; justify-content: center; gap: 1.2rem; flex-wrap: wrap; }

  /* ── Privacy overlay ── */
  .s-policy {
    max-width: 780px; margin: 0 auto;
    padding: 4rem 2rem 5rem;
    font-family: Arial, sans-serif; font-size: 14px;
    color: #595959; line-height: 1.85;
  }
  .s-policy-header {
    display: flex; justify-content: space-between; align-items: center;
    margin-bottom: 2rem; border-bottom: 2px solid var(--rose); padding-bottom: 1rem;
  }
  .s-policy h1 { font-size: 24px; color: #000; margin-bottom: 4px; }
  .s-policy h2 { font-size: 16px; color: #000; margin-top: 2rem; margin-bottom: 0.6rem; }
  .s-policy p { margin-bottom: 0.9rem; }
  .s-policy ul { padding-left: 1.4rem; margin-bottom: 0.9rem; }
  .s-policy li { margin-bottom: 0.35rem; }
  .s-policy a { color: var(--rose); }
  .s-policy a.s-close-btn,
  .s-policy a.s-back-btn {
    color: white;
    text-decoration: none;
  }
  .s-close-btn {
    background: var(--rose); color: white; border: none;
    width: 2.4rem; height: 2.4rem; border-radius: 100px;
    font-family: 'DM Sans', sans-serif; cursor: pointer;
    text-decoration: none;
    display: inline-flex; align-items: center; justify-content: center;
    flex-shrink: 0;
    transition: background 0.2s, transform 0.15s;
  }
  .s-close-btn:hover { background: var(--mauve); transform: scale(1.05); }
  .s-close-icon {
    display: block;
    flex-shrink: 0;
  }
  .s-back-btn {
    display: block; margin: 2rem auto 0;
    background: var(--rose); color: white; border: none;
    padding: 0.75rem 2rem; border-radius: 100px;
    font-family: 'DM Sans', sans-serif; font-size: 0.9rem;
    cursor: pointer; text-decoration: none; text-align: center;
    width: fit-content;
  }

  .s-notice {
    background: var(--blush);
    border-left: 4px solid var(--rose);
    padding: 1rem 1.25rem;
    border-radius: 0 8px 8px 0;
    margin-bottom: 2rem;
    font-size: 0.9rem;
    color: #595959;
    line-height: 1.7;
  }

  .s-contact-block {
    background: var(--blush);
    border-radius: 12px;
    padding: 1.5rem;
    margin-top: 1rem;
    font-size: 0.95rem;
    color: #595959;
    line-height: 2;
  }

  /* ── Support page ── */
  .s-support-hero {
    background: linear-gradient(160deg, #fff 0%, var(--blush) 60%, #fff 100%);
    padding: 7rem 2rem 3rem;
    text-align: center;
  }
  .s-support-hero h1 {
    font-family: 'Playfair Display', serif;
    font-size: clamp(2rem, 5vw, 3rem);
    letter-spacing: -0.02em;
    margin-bottom: 0.75rem;
    color: var(--text);
  }
  .s-support-hero h1 em { font-style: italic; color: var(--rose); }
  .s-support-hero p {
    font-size: 1rem; color: var(--muted); font-weight: 300;
    max-width: 460px; margin: 0 auto;
  }

  .s-support-container {
    max-width: 780px; margin: 0 auto;
    padding: 3rem 2rem 5rem;
  }

  .s-support-section { margin-bottom: 3.5rem; }

  .s-section-title {
    font-family: 'Playfair Display', serif;
    font-size: 1.5rem; color: var(--text);
    margin-bottom: 1.25rem; padding-bottom: 0.5rem;
    border-bottom: 2px solid var(--pink);
  }

  .s-email-card {
    display: flex; align-items: center; gap: 1.25rem;
    background: var(--blush); border-radius: 16px;
    padding: 1.5rem 2rem; text-decoration: none;
    transition: transform 0.15s;
  }
  .s-email-card:hover { transform: translateY(-2px); }
  .s-email-icon {
    width: 52px; height: 52px; background: var(--rose);
    border-radius: 14px; display: flex; align-items: center;
    justify-content: center; font-size: 22px; flex-shrink: 0;
  }
  .s-email-card h3 {
    font-size: 1rem; font-weight: 500; color: var(--text); margin-bottom: 2px;
  }
  .s-email-card p { font-size: 0.88rem; color: var(--muted); margin: 0; }

  .s-howto-card {
    background: #fff;
    border: 1.5px solid rgba(244,167,192,0.4);
    border-radius: 16px; padding: 1.5rem; margin-bottom: 1rem;
  }
  .s-howto-card h3 {
    font-size: 1rem; font-weight: 500; color: var(--rose);
    margin-bottom: 0.75rem;
    display: flex; align-items: center; gap: 8px;
  }
  .s-howto-card ol {
    padding-left: 1.25rem; color: #595959; font-size: 0.92rem;
  }
  .s-howto-card ol li { margin-bottom: 0.4rem; }
  .s-howto-note {
    margin-top: 0.75rem; font-size: 0.85rem; color: var(--muted);
    background: var(--blush); padding: 0.6rem 0.9rem; border-radius: 8px;
  }

  .s-contact-form { display: flex; flex-direction: column; gap: 1rem; }
  .s-form-row {
    display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;
  }
  .s-form-group {
    display: flex; flex-direction: column; gap: 6px;
  }
  .s-form-group label {
    font-size: 0.85rem; font-weight: 500; color: var(--text);
  }
  .s-form-group input,
  .s-form-group select,
  .s-form-group textarea {
    padding: 0.8rem 1rem;
    border: 1.5px solid rgba(244,167,192,0.5);
    border-radius: 10px;
    font-family: 'DM Sans', sans-serif; font-size: 0.92rem;
    color: var(--text); background: white; outline: none;
    transition: border-color 0.2s; resize: vertical;
  }
  .s-form-group input:focus,
  .s-form-group select:focus,
  .s-form-group textarea:focus { border-color: var(--rose); }
  .s-form-group input::placeholder,
  .s-form-group textarea::placeholder { color: #bbb; }

  .s-btn-submit {
    background: var(--rose); color: white; border: none;
    padding: 0.9rem 2rem; border-radius: 100px;
    font-family: 'DM Sans', sans-serif; font-size: 0.95rem; font-weight: 500;
    cursor: pointer; align-self: flex-start;
    transition: background 0.15s, transform 0.15s;
    box-shadow: 0 4px 20px rgba(212,83,126,0.25);
  }
  .s-btn-submit:hover { background: var(--mauve); transform: translateY(-2px); }

  .s-form-success {
    background: var(--blush); border-radius: 12px;
    padding: 1.25rem 1.5rem; color: var(--mauve);
    font-weight: 500; font-size: 0.95rem; text-align: center;
  }

  /* ── Animations ── */
  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(18px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  /* ── Responsive ── */
  @media (max-width: 600px) {
    .s-nav { padding: 1rem 1.2rem; }
    .s-hero { padding: 8rem 1.2rem 4rem; }
    .s-features, .s-shots, .s-tracker { padding: 4rem 1.2rem; }
    .s-chat { padding: 4rem 1.2rem; }
    .s-cta { padding: 4rem 1.2rem; }
    .s-support-hero { padding: 7rem 1.2rem 3rem; }
    .s-support-container { padding: 3rem 1.2rem 5rem; }
    .s-form-row { grid-template-columns: 1fr; }
  }
`;
